// src/features/rrhh/horarios/components/HorariosToolbar.jsx
import {
  Chip,
  IconButton,
  Stack,
} from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function HorariosToolbar({
  cursorLabel,
  onPrev,
  onNext,
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        px: 2,
        py: 0.5,
        bgcolor: "neutral.50",
        borderRadius: "20px",
        boxShadow: "inset 0px 0px 4px rgba(165, 165, 178, 1)",
      }}
    >
      <IconButton onClick={onPrev} sx={{ width: 32, height: 32 }}>
        <ChevronLeftIcon sx={{ fontSize: 28, color: "primary.900" }} />
      </IconButton>

      <Chip
        label={cursorLabel}
        sx={{
          px: 2,
          py: 1,
          bgcolor: "secondary.200",
          boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
          borderRadius: "33px",
          "& .MuiChip-label": { fontSize: "14px", fontWeight: 600, color: "primary.900", padding: 0 },
        }}
      />

      <IconButton onClick={onNext} sx={{ width: 32, height: 32 }}>
        <ChevronRightIcon sx={{ fontSize: 28, color: "primary.900" }} />
      </IconButton>
    </Stack>
  );
}
